/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListDepositsOptions,
  ListDepositsStatus200,
  ListDepositsStatus400,
  ListDepositsStatus401,
  ListDepositsStatus403,
  ListDepositsStatus500,
} from '../types/ListDeposits'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listDeposits } from '../clients/listDeposits'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listDepositsQueryKey = ({ query }: Omit<ListDepositsOptions, 'headers'> = {}) =>
  [{ url: '/v1/web3/deposits' }, ...(query ? [query] : [])] as const

type ListDepositsQueryKey = ReturnType<typeof listDepositsQueryKey>

export function listDepositsQueryOptions(
  { query }: ListDepositsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listDepositsQueryKey({ query })
  return queryOptions<
    ListDepositsStatus200,
    ResponseErrorConfig<
      ListDepositsStatus400 | ListDepositsStatus401 | ListDepositsStatus403 | ListDepositsStatus500
    >,
    ListDepositsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listDeposits({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Lists USDC deposits ordered by observed_at descending. Admin users may list deposits for any user (or all users); non-admin users may only list their own deposits.
 * @summary List USDC deposits
 * {@link /v1/web3/deposits}
 */
export function useListDeposits<
  TData = ListDepositsStatus200,
  TQueryData = ListDepositsStatus200,
  TQueryKey extends QueryKey = ListDepositsQueryKey,
>(
  { query }: { query?: ListDepositsOptions['query'] | (() => ListDepositsOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListDepositsStatus200,
        ResponseErrorConfig<
          | ListDepositsStatus400
          | ListDepositsStatus401
          | ListDepositsStatus403
          | ListDepositsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listDepositsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listDepositsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      ListDepositsStatus400 | ListDepositsStatus401 | ListDepositsStatus403 | ListDepositsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
